import React from "react";

// Ghost/outline CTA with an animated gradient sweep that fills on hover.
export const GhostButton = ({ as = "a", children, className = "", ...props }) => {
  const Comp = as;
  return (
    <Comp
      className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full border border-border-dim px-8 py-3.5 font-medium text-text-main transition-transform active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary focus-visible:ring-offset-2 focus-visible:ring-offset-main ${className}`}
      {...props}
    >
      <span
        aria-hidden="true"
        className="ghost-sweep absolute inset-0 z-0 bg-gradient-to-r from-theme-primary to-theme-secondary"
      />
      <span className="relative z-10 inline-flex items-center gap-2 transition-colors duration-300 group-hover:text-black">
        {children}
      </span>
    </Comp>
  );
};
